import script from "./keyItem.vue?vue&type=script&setup=true&lang=js"
export * from "./keyItem.vue?vue&type=script&setup=true&lang=js"

import "./keyItem.vue?vue&type=style&index=0&id=7471a804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7471a804"]])

export default __exports__